// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { initializeFirestore, getFirestore, memoryLocalCache } from 'firebase/firestore';
import {getAuth, GoogleAuthProvider, signInWithPopup, signOut} from "firebase/auth";
import type { Analytics } from "firebase/analytics";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase web app configuration.
// These values are NOT secrets: the Firebase web config is public by design —
// it only identifies the project, access is enforced by Firestore rules + Auth.
// They are hardcoded as the source of truth so a missing/empty CI env var can
// never white-screen prod (2026-05-19 outage). VITE_FIREBASE_* override when set.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBe_9hOsL9Ee9-ztIZKkYgBNyp8Ja0KWl0',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'footinthedoor.ch',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'diamond-532b3',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'diamond-532b3.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '495157735931',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:495157735931:web:17138d6f686d25239f1b5e',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-YEL11ZFMBW',
};

// Initialize Firebase - prevent multiple instances (HMR safe)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Crée une instance de Firestore - prevent reinitialization errors
// Note: certaines extensions (adblock, privacy) peuvent bloquer WebChannel.
// Auto-detect le long-polling réduit les soucis réseau sans forcer une dégradation partout.
let db: ReturnType<typeof getFirestore>;

function initializeDb() {
  try {
    // Try to get existing instance first (prevents HMR reinitialization errors)
    db = getFirestore(app);
  } catch {
    // If no instance exists, initialize with settings
    // Using memory cache to avoid IndexedDB corruption issues (Firebase 11.x bug)
    db = initializeFirestore(app, {
      experimentalAutoDetectLongPolling: true,
      localCache: memoryLocalCache()
    });
  }
  return db;
}

// Initialize on module load
initializeDb();

// Récupération du service d'authentification
const auth = getAuth(app);

// Configuration du GoogleAuthProvider avec scopes et paramètres
const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
// Forcer la sélection du compte pour éviter les problèmes de session
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Firebase Analytics is loaded conditionally by CookieConsentContext
// when the user grants analytics consent.
let analytics: Analytics | null = null;


// Communication sécurisée avec le plugin Chrome via postMessage
if (typeof window !== 'undefined') {
  // Écoute les messages du plugin Chrome pour retourner le Firebase ID token
  window.addEventListener('message', async (event) => {
    // Sécurité: n'accepter que les messages de même origin (content scripts Chrome partagent l'origin de la page)
    if (event.origin !== window.location.origin) return;

    if (event.data && event.data.type === 'FITD_GET_ID_TOKEN' && event.data.source === 'fitd-chrome-extension') {
      const targetOrigin = window.location.origin;
      try {
        const user = auth.currentUser;
        if (user) {
          const idToken = await user.getIdToken();
          window.postMessage({
            type: 'FITD_ID_TOKEN_RESPONSE',
            token: idToken,
            source: 'fitd-web-app'
          }, targetOrigin);
        } else {
          window.postMessage({
            type: 'FITD_ID_TOKEN_RESPONSE',
            token: null,
            error: 'User not authenticated',
            source: 'fitd-web-app'
          }, targetOrigin);
        }
      } catch (error: any) {
        window.postMessage({
          type: 'FITD_ID_TOKEN_RESPONSE',
          token: null,
          error: error.message || 'Error getting token',
          source: 'fitd-web-app'
        }, targetOrigin);
      }
    }
  });
}

// Exporte db
// Note : `storage` et `functions` sont exportés par `firebase-storage.ts` et
// `firebase-functions.ts` pour que `firebase/storage` et `firebase/functions`
// ne soient tirés dans le bundle que par les modules qui les utilisent.
export { db, app, auth, googleProvider, signInWithPopup, signOut, analytics };
